import { key } from "./key";
var CryptoJS = require("crypto-js");

export const getLoginInfo = () => {
    try {
        let data;
        data = localStorage.getItem('doctoraU');
        var bytes = CryptoJS.AES.decrypt(data, key);
        var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return JSON.parse(decryptedData)
    } catch (error) {
        return null;
    }
}